import { useCallback, useState, useEffect } from 'react';
import { debounce, DebounceSettings } from 'lodash';

export const useDebouncedFunction = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fn: (...args: any) => any,
  delay: number,
  options?: DebounceSettings | undefined
) => {
  return useCallback(debounce(fn, delay, options), []);
};

export const useDebouncedState = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any,
  delay: number
) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};
